<template>
  <el-card class="h-full">
    <div class="w-full h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mr-10px">
        <el-select
          v-model="equipSearchData.personnelId"
          size="small"
          class="mr-10px !w-50"
          placeholder="请选择人员"
          clearable
          filterable
        >
          <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px"
          v-model="equipSearchData.datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button
          size="small"
          @click="handleEvent(null, 'batchExport')"
          :disabled="!$hasAccess('batchExport')"
          >导出</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
        @selection-change="handleSelectionEquip"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="被考核对象"
          prop="assessorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属单位/部门"
          prop="departmentName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="考核周期" prop="assessmentCycleEndTime" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.assessmentCycleStartTime
                ? dayjs(scope.row.assessmentCycleStartTime).format('YYYY-MM-DD')
                : ''
            }}
            -
            {{
              scope.row.assessmentCycleEndTime
                ? dayjs(scope.row.assessmentCycleEndTime).format('YYYY-MM-DD')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="考核积分"
          prop="evaluationScore"
          sortable
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <person-check-detail
      :currentId="currentId"
      v-if="currentComp === 'DETAIL'"
      @cancel="checkComp('TABLE')"
    ></person-check-detail>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import { UserApi } from '@wiz-api/abp-identity'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { PersonnelEvaluationApi } from '@wiz-api/double-prevention-management'
import PersonCheckDetail from '../components/CheckDetail/PersonCheckDetail'

const personnelEvaluationApi = new PersonnelEvaluationApi()
const userApi = new UserApi()

export default {
  name: 'person-check',
  components: {
    TableOperateButton,
    PersonCheckDetail,
  },
  data() {
    return {
      currentId: undefined,
      userList: [],
      currentComp: 'TABLE',
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        personnelId: undefined,
        datePickerValue: [],
        startTime: undefined,
        endTime: undefined,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
    }
  },
  created() {
    this.handleSearch()
    this.getUserList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
        ]
      }
    },
  },
  methods: {
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 重置
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.handleSearch()
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'read':
          this.currentId = row.id
          this.checkComp('DETAIL')
          break
        case 'batchExport':
          ;[err, res] = await personnelEvaluationApi.exportPersonnelEvaluation({
            body:
              this.selectionEquipData && this.selectionEquipData.length > 0
                ? this.selectionEquipData
                : undefined,
          })
          if (!err) {
            this.downLoadExcel('人员考核记录', res)
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
          }
          break
        default:
          break
      }
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await userApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values.map((item) => {
        return item.id
      })
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      this.equipSearchData.startTime =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[0]).format('YYYY-MM-DD')
          : undefined
      this.equipSearchData.endTime =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[1]).format('YYYY-MM-DD')
          : undefined
      const equipSearchData = utils.deleteFormField(this.equipSearchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await personnelEvaluationApi.getPersonnelEvaluationList(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
